import { ReactNode, useMemo } from 'react';

// material-ui
import { alpha, useTheme } from '@mui/material/styles';
import { AppBar, Toolbar, AppBarProps, Typography } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
// project-imports
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';

import IconButton from 'components/@extended/IconButton';
import { DRAWER_WIDTH} from 'config';
import useConfig from 'hooks/useConfig';

// assets
import { HambergerMenu } from 'iconsax-react';

// typs
import { LAYOUT_CONST } from 'types/config';
import useAuth from 'hooks/useAuth';
import { useSelector } from 'store';
import Avatar from 'components/@extended/Avatar';
import { useNavigate } from 'react-router';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

interface Props {
  open: boolean;
  handleDrawerToggle?: () => void;
}

const Header = ({ open, handleDrawerToggle }: Props) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user } = useAuth();
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));
  const { menuOrientation } = useConfig();

  const isHorizontal = menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG;
  const { mode } = useConfig();
  // header content
  const headerContent = useMemo(() => <HeaderContent />, []);
  const setting: any = useSelector((state) => state.organization)?.logo;
  const organization: any = useSelector((state) => state.organization);



  // common header
  const mainHeader: ReactNode = (
    <Toolbar id="header-nav" sx={{ mr: { xs: 1, sm: 3.5, lg: 4 } }}>
      {!isHorizontal ? (
        <>
        
            <Typography
              onClick={() => navigate(user?.type === 'faculty' ? '/faculty' : '/dashboard')}
              sx={{
                color: '#0073A8',
                fontWeight: 700,
                fontSize: { xs: 12, sm: 14, md: 16 },
                p: 0,
                fontFamily: 'revert',
                display: { xs: 'none', md: 'block' },
                textTransform: 'capitalize',
                cursor: 'pointer',
                width:DRAWER_WIDTH,
                
              }}
            >
              
              {user?.type === 'superadmin' ? 'Super Admin' : organization?.setting?.identity?.site_name || organization?.name}
              
            </Typography>
          

          <IconButton
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            edge="start"
            color="secondary"
            variant="light"
            size="large"
            sx={{ color: 'secondary.main', backgroundColor: 'transparent'}}
          >
            <HambergerMenu className={mode ? 'mainlogoicon' : ''} />
          </IconButton>

          {/* <Avatar
            src={
              setting?.[0]?.path
                ? process.env.REACT_APP_FILE_URL + setting?.[0]?.path
                : `data:${setting?.[0]?.mimetype};base64,${setting?.[0]?.file}`
            }
            onClick={() => navigate(user?.type === 'faculty' ? '/faculty' : '/dashboard')}
            sx={{
              mx: 1,
              display: { xs: 'block', md: 'none' },
              objectFit: 'contain',
              border: '1px solid',
              borderColor: theme.palette.primary.main,
              bgcolor: 'transparent',
              cursor: 'pointer'
            }}
          /> */}
        </>
      ) : null}
      {headerContent}
    </Toolbar>
  );

  // app-bar params
  const appBar: AppBarProps = {
    position: 'fixed',
    elevation: 0,
    sx: {
      bgcolor: alpha(theme.palette.background.default, 0.8),
      backdropFilter: 'blur(10px)',
      zIndex: 1300,                                       
      boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
      borderRadius: ['0px 0px 15px 15px', '0px 0px 15px 15px', '0px 0px 15px 0px'],
      width: '100%'
    }
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={open} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
};

export default Header;
